/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ what: NonNullable<unknown> }} Overlap_LeftoversInputs */

const en_overlap_leftovers = /** @type {(inputs: Overlap_LeftoversInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Left over this week: ${i?.what}`)
};

const de_overlap_leftovers = /** @type {(inputs: Overlap_LeftoversInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bleibt diese Woche übrig: ${i?.what}`)
};

/**
* | output |
* | --- |
* | "Left over this week: {what}" |
*
* @param {Overlap_LeftoversInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const overlap_leftovers = /** @type {((inputs: Overlap_LeftoversInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overlap_LeftoversInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_overlap_leftovers(inputs)
	return en_overlap_leftovers(inputs)
});